export const TEMPLATES_ROUTE = '/templates'
